// extracted by mini-css-extract-plugin
module.exports = {"icon":"modal-confirmation_icon__WKnoC","message":"modal-confirmation_message__38L8g"};